import React from 'react';
import { Alert, Table } from 'reactstrap';

export default class CrewOverlapDisplay extends React.Component {
    getOtherCrewEmployeeMemberships = () => {
        const { crew, employees } = this.props;

        return employees
            .filter((e) => crew.crewEmployeeMemberships.includes(e.id))
            .map((e) => {
                return {
                    employeeId: e.id,
                    otherCrewIds: e.crewIds.filter((ci) => ci != crew.id),
                };
            })
            .filter((oce) => oce.otherCrewIds.length > 0);
    };

    getOtherCrewEquipmentMemberships = () => {
        const { crew, equipment } = this.props;

        return equipment
            .filter((eq) => crew.crewEquipmentMemberships.includes(eq.id))
            .map((eq) => {
                return {
                    equipmentId: eq.id,
                    otherCrewIds: eq.crewIds.filter((ci) => ci != crew.id),
                };
            })
            .filter((oce) => oce.otherCrewIds.length > 0);
    };

    render() {
        const { loading, crew, employees, equipment, crews } = this.props;

        if (loading || !crew || !employees || !equipment) {
            return null;
        }

        const otherCrewEquipmentMemberships =
            this.getOtherCrewEquipmentMemberships();

        const otherCrewEmployeeMemberships =
            this.getOtherCrewEmployeeMemberships();

        if (
            !otherCrewEmployeeMemberships.length &&
            !otherCrewEquipmentMemberships.length
        ) {
            return null;
        }

        return (
            <Alert fade={false} color="warning">
                <div>Other Crew Assignments</div>

                {otherCrewEmployeeMemberships.length > 0 && (
                    <div className="other-employee-memberships">
                        <Table striped size="sm">
                            <thead>
                                <tr>
                                    <th>Employee</th>
                                    <th>Other Crew(s)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {otherCrewEmployeeMemberships.map((oce) => {
                                    const employee = employees.find(
                                        (e) => e.id == oce.employeeId
                                    );

                                    const otherCrews = crews.filter((c) =>
                                        oce.otherCrewIds.includes(c.id)
                                    );

                                    return (
                                        <tr key={oce.employeeId}>
                                            <td>
                                                {employee.lastName},{' '}
                                                {employee.firstName} (
                                                {employee.employeeNumber})
                                            </td>
                                            <td>
                                                {otherCrews.map((oc) => (
                                                    <div
                                                        key={`${oce.employeeId}-cr${oc.id}`}
                                                    >
                                                        {oc.name}
                                                    </div>
                                                ))}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </div>
                )}

                {otherCrewEquipmentMemberships.length > 0 && (
                    <div className="other-equipment-memberships">
                        <Table striped size="sm">
                            <thead>
                                <tr>
                                    <th>Equipment</th>
                                    <th>Other Crew(s)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {otherCrewEquipmentMemberships.map((oceq) => {
                                    const otherEquipment = equipment.find(
                                        (eq) => eq.id == oceq.equipmentId
                                    );

                                    const otherCrews = crews.filter((c) =>
                                        oceq.otherCrewIds.includes(c.id)
                                    );

                                    return (
                                        <tr key={oceq.equipmentId}>
                                            <td>
                                                {otherEquipment.identifier} -{' '}
                                                {otherEquipment.description}
                                            </td>
                                            <td>
                                                {otherCrews.map((oc) => (
                                                    <div
                                                        key={`${oceq.equipmentId}-cr${oc.id}`}
                                                    >
                                                        {oc.name}
                                                    </div>
                                                ))}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </div>
                )}
            </Alert>
        );
    }
}
